import React, { Component } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  TextareaAutosize,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import {
  contentRequestTypes,
  contRequestTypesList,
  messageTypes,
  contentRequestStatus,
  contentRequestPriorityList,
  contentRequestPrposedUsageList,
  attachmentTypes
} from "./Const";
import { TextInput } from "../../util/input-elements/TextInput";
import {  _newContentMessage } from "./Utils";
import { defaultGroups } from "../../redux/Types";
import Grid from '@material-ui/core/Grid';
import { deepCopyFunction } from "util/CommonFunc";
 

export default class ContentRequest extends Component {

initialState = {
  // priority: contentRequestPriority.P4,
  priority: null,
  // type: contentRequestTypes.TRACK,
  type: null,
  proposedUsage: null,
  errors:null,
  trackDetails: {
    trackArtist: "",
    trackTitle: "",
    catNumber: "",
    notes: "",
    album: "",
    recordLabel: "",
    publisher: "",
    altTrackTitle: "",
    distributor: "",
  },
  albumDetails: {
    albumArtist: "",
    albumTitle: "",
    catNumber: "",
    notes: "",
    recordLabel: "",
    publisher: "",
    distributor: "",
  },
}

  constructor(props) {
    super();
    this.state = {
      ...deepCopyFunction(this.initialState)
    };
  }

  setInitialState() {
    this.setState({
      ...deepCopyFunction(this.initialState) });
  }

  handleValChange = (event, mainField = false) => {
    const { type } = this.state;    
    let key = event.target.name;
    let value = event.target.value;

    let prvType = null;
    if(key === "type") prvType = this.state.type;

    if(mainField){
      this.setState({ 
        [key]: value,
        errors:null,
       }, ()=>{
        if(key === "type" && this.state.type && ((this.state.type !== prvType && value === contentRequestTypes.ALBUM) || (this.state.type !== prvType && prvType === contentRequestTypes.ALBUM))){
          this.setState({
            trackDetails: deepCopyFunction(this.initialState.trackDetails),
            albumDetails: deepCopyFunction(this.initialState.albumDetails),
            proposedUsage: null,
            errors:null,
          });
        }
      });
    }else{
      if (type !== contentRequestTypes.ALBUM) {
        this.setState((prevstate)=>({
          trackDetails :{
            ...prevstate.trackDetails,
            [key] : value
          },
          errors: null
        }));
      } else {
        this.setState((prevstate)=>({
          albumDetails :{
            ...prevstate.albumDetails,
            [key] : value
          },
          errors: null
        }));
      }
    }
    
  };


  sendAndCreateNew = (event)=>{
    this.clickCreate(event, true);
  }

  clickCreate = (event, sendAndNew = false) => {
    const { DialogClose,validateCR, postMessage
  } = this.props;

    validateCR(
      {
        priority : this.state.priority,
        type : this.state.type,
        proposedUsage: this.state.proposedUsage,
        ...(this.state.type !== contentRequestTypes.ALBUM ? this.state.trackDetails : this.state.albumDetails)
      }, 
      (error) => {
    if(!error){
      let msg = {}
      if (this.state.type !== contentRequestTypes.ALBUM) {
        msg =  _newContentMessage(
            messageTypes.CONTENT_REQUEST,
            [
              {
                id: "",
                title: this.state.trackDetails.trackTitle,
                artist: this.state.trackDetails.trackArtist,
                album: this.state.trackDetails.album,
                catNumber: this.state.trackDetails.catNumber,
                recordLabel: this.state.trackDetails.recordLabel,
                publisher: this.state.trackDetails.publisher,
                altTrackTitle: this.state.trackDetails.altTrackTitle,
                distributor: this.state.trackDetails.distributor,
                contentType: this.state.type,
                priority: this.state.priority,
                proposedUsage: this.state.proposedUsage,
                type: attachmentTypes.CONTENT_REQUEST
              },
            ],
            this.state.trackDetails.trackTitle,
            this.state.trackDetails.notes,
            [],
            [defaultGroups.CONTENT_GROUP],
            contentRequestStatus.REQUESTED,

            this.state.trackDetails.trackTitle,
            this.state.trackDetails.trackArtist,
            this.state.type,
            this.state.priority,
            this.state.proposedUsage,
          );
      }
      else{
         msg =  _newContentMessage(
            messageTypes.CONTENT_REQUEST,
            [
              {
                id: "",
                title: this.state.albumDetails.albumTitle,
                artist: this.state.albumDetails.albumArtist,
                catNumber: this.state.albumDetails.catNumber,
                recordLabel: this.state.albumDetails.recordLabel,
                publisher: this.state.albumDetails.publisher,
                distributor: this.state.albumDetails.distributor,
                contentType: this.state.type,
                priority: this.state.priority,
                proposedUsage: this.state.proposedUsage,
              },
            ],
            this.state.albumDetails.albumTitle,
            this.state.albumDetails.notes,
            [],
            [defaultGroups.CONTENT_GROUP],
            contentRequestStatus.REQUESTED,

            this.state.albumDetails.albumTitle,
            this.state.albumDetails.albumArtist,
            this.state.type,
            this.state.priority,
            this.state.proposedUsage,
          )
      }

      postMessage("savemessage", "Sending Content Request...", { message: msg }, (data, error) => { });

      this.setInitialState();
      if(!sendAndNew)DialogClose();
    }
    else{
      this.setState({ errors: error });
      return
    }
    }); 
  }

  render() {
    const {
      DialogOpen,
      DialogClose,
      classes,
    } = this.props;

    const { type, priority, proposedUsage } = this.state;
    
    return (
       <div className={classes.dialogMinWidth}> 
      <Dialog
        open={DialogOpen}
        id="content-request-dialog"
        aria-labelledby="content-request-dialog"
        className={classes.dialogWrapper}       
        class="dialogBox2"
        scroll={'paper'}
      >
        <DialogTitle id="alert-dialog-title">       
        <div className={classes.modalContentHeader}>
        <div className={classes.modalContentTitle}> 
         Content Request -{" "}
          {type === contentRequestTypes.ALBUM ? "Album" : "Track"}
            </div> 
            <Button
              aria-label="Close Content Request"
              className={clsx(
                classes.closeButton
              )}
              title="Close"
              onClick={() =>{                
                this.setInitialState();
                DialogClose();
              } }
            >
              <CloseIcon />
            </Button>
         </div>
        </DialogTitle>

        <DialogContent dividers={true} className={classes.modalContentWidth}>
        <div className={classes.modalMsgContentInner}>
          <div  className={clsx(classes.globalContentCreate,classes.globalContentCreateAddPadding, classes.smallIntro)}>
            This form is not for clearances, please email <a className={classes.globalExternalLink} href="mailto:MusicLicensingQueries@bbc.co.uk" title="mailto:MusicLicensingQueries@bbc.co.uk">MusicLicensingQueries@bbc.co.uk</a> for any clearance related questions <u>or advice on clearing music not currently on MusicBox.</u>
          </div>
        <Grid container spacing={3}>
        <Grid item xs={12}>
        <div  className={clsx(classes.globalContentCreate,classes.globalContentCreateAddPadding,this.state.errors && this.state.errors['priority']? classes.emptyData : null)}>
            <label
              className={classes.globalCreateLabel}
              aria-label="Select field for priority level"
            >
              Priority Level<span aria-label="track name required" className={classes.reqSymbol}>*</span> :{" "}
            </label>
            <Select
              id="priority"
              key="priority"
              name="priority"
              variant="outlined"
              aria-label={"Select content request priority level"}
              inputProps={{
                id: "priority",
                "aria-labelledby": "priority",
                "aria-label": "Select content request priority level"
              }}
              autoFocus
              className={clsx(
                classes.contentHelpDropdown,
                this.state?.errors?.priority ? classes.globalSelectEmptyError : null,
                )}
              fullWidth
              value={priority}
              // onChange={this.handlePriorityChange}
              onChange={(e)=>this.handleValChange(e, true)}
              displayEmpty
              renderValue={
                priority !== null ? undefined : () => "Please Select"
              }
            >
              {contentRequestPriorityList.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
            { this.state.errors && this.state.errors['priority'] && (
              <span>{this.state.errors['priority']}</span>
              )}
            <span className={classes.priorityText}>{priority ? contentRequestPriorityList[contentRequestPriorityList.findIndex(v => v.id === priority)]?.infoText : ""}</span>
          </div>
        <div className={clsx(classes.globalContentCreate ,classes.globalContentCreateAddPadding, this.state.errors && this.state.errors['type']? classes.emptyData : null )}>
            <label
              className={classes.globalCreateLabel}
              aria-label="Input field for track name"
            >
              Type<span aria-label="track name required" className={classes.reqSymbol}>*</span> :{" "}
            </label>
            <Select
              id="type"
              key="type"
              name="type"
              variant="outlined"
              aria-label={"Select content request type"}
              inputProps={{
                id: "type",
                "aria-labelledby": "type",
                "aria-label": "Select content request type"
              }}
              className={clsx(
                classes.contentHelpDropdown,
                this.state?.errors?.type ? classes.globalSelectEmptyError : null,
                )}
              fullWidth
              value={type}
              onChange={(e)=>this.handleValChange(e, true)}
              displayEmpty
              renderValue={
                type !== null ? undefined : () => "Please Select"
              }
            >
              {contRequestTypesList.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
            { this.state.errors && this.state.errors['type'] && (
              <span>{this.state.errors['type']}</span>
              )}
            <span className={classes.priorityText}>{type ? contRequestTypesList[contRequestTypesList.findIndex(v => v.id === type)]?.infoText : ""}</span>
          </div>

          <div className={clsx(classes.globalContentCreate , classes.globalContentCreateAddPadding, this.state.errors && this.state.errors['proposedUsage']? classes.emptyData : null )}>
            <label
                className={classes.globalCreateLabel}
                aria-label="Input field for track name"
              >
              Proposed Usage<span aria-label="track name required" className={classes.reqSymbol}>*</span> :{" "}
            </label>
            <Select
              id="proposedUsage"
              key="proposedUsage"
              name="proposedUsage"
              variant="outlined"
              aria-label={"Select content request proposed usage"}
              inputProps={{
                id: "proposedUsage",
                "aria-labelledby": "proposedUsage",
                "aria-label": "Select content request proposed usage"
              }}
              className={clsx(
                classes.contentHelpDropdown,
                this.state?.errors?.proposedUsage ? classes.globalSelectEmptyError : null,
                )}
              fullWidth
              value={proposedUsage}
              onChange={(e)=>this.handleValChange(e, true)}
              displayEmpty
              renderValue={
                proposedUsage !== null ? undefined : () => "Please Select"
              }
            >
              {contentRequestPrposedUsageList.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
            { this.state.errors && this.state.errors['proposedUsage'] && (
              <span>{this.state.errors['proposedUsage']}</span>
              )}
          </div>
        </Grid>
       
        {type !== contentRequestTypes.ALBUM && (
            <>
              <Grid item xs={6}>
                <div className={classes.globalContentCreate}>
                  <label
                    className={classes.globalCreateLabel}
                    aria-label="Input field for track name"
                  >
                    Title<span aria-label="track name required" className={classes.reqSymbol}>*</span> :{" "}
                  </label>
                  <TextInput
                    name="trackTitle"
                    type="text"
                    classes={classes}
                    handleChange={this.handleValChange}
                    errors={this.state.errors || {}}
                    selectOnFocus={true}
                    inputProps={{
                      "aria-label": "trackTitle",
                    }}
                    value={this.state.trackDetails.trackTitle || ""}
                  />
                </div>
              </Grid>
              <Grid item xs={6}>
                  <div className={classes.globalContentCreate}>
                      <label
                        className={classes.globalCreateLabel}
                        aria-label="Input field for track artist"
                      >
                        Artist<span aria-label="track artist required" className={classes.reqSymbol}>*</span> :{" "}
                      </label>
                      <TextInput
                        name="trackArtist"
                        type="text"
                        classes={classes}
                        handleChange={this.handleValChange}
                        errors={this.state.errors || {}}
                        inputProps={{
                          "aria-label": "artist",
                        }}
                        value={this.state.trackDetails.trackArtist || ""}
                      />
                    </div>
                </Grid>  

                <Grid item xs={6}>
                <div className={classes.globalContentCreate}>
                      <label
                        className={classes.globalCreateLabel}
                        aria-label="Input field for album"
                      >
                        Album :{" "}
                      </label>
                      <TextInput
                        name="album"
                        type="text"
                        classes={classes}
                        handleChange={this.handleValChange}
                        errors={this.state.errors || {}}
                        inputProps={{
                          "aria-label": "album",
                        }}
                        value={this.state.trackDetails.album || ""}
                      />
                    </div>
              </Grid>
       

              <Grid item xs={6}>
              <div className={classes.globalContentCreate}>
                  <label
                    className={classes.globalCreateLabel}
                    aria-label="Input field for Catalog #"
                  >
                    Catalog # :{" "}
                  </label>
                  <TextInput
                    name="catNumber"
                    type="text"
                    classes={classes}
                    handleChange={this.handleValChange}
                    errors={this.state.errors || {}}
                    inputProps={{
                      "aria-label": "Catalog #",
                    }}
                    value={this.state.trackDetails.catNumber || ""}
                  />
                </div>
              </Grid>    

        </>
          )}

        {type === contentRequestTypes.ALBUM && (
            <>
              <Grid item xs={12}>
                <div className={classes.globalContentCreate}>
                    <label
                      className={classes.globalCreateLabel}
                      aria-label="Input field for album title"
                    >
                      Title<span  aria-label="album title required" className={classes.reqSymbol}>*</span> :{" "}
                    </label>
                    <TextInput
                      name="albumTitle"
                      type="text"
                      classes={classes}
                      handleChange={this.handleValChange}
                      errors={this.state.errors || {}}
                      selectOnFocus={true}
                      inputProps={{
                        "aria-label": "albumTitle",
                      }}
                      value={this.state.albumDetails.albumTitle || ""}
                    />
                </div>             
              </Grid> 

              <Grid item xs={6}>
              <div className={classes.globalContentCreate}>
                      <label
                        className={classes.globalCreateLabel}
                        aria-label="Input field for album artist"
                      >
                        Album Artist<span aria-label="album artist required" className={classes.reqSymbol}>*</span> :{" "}
                      </label>
                      <TextInput
                        name="albumArtist"
                        type="text"
                        classes={classes}
                        handleChange={this.handleValChange}
                        errors={this.state.errors || {}}
                        inputProps={{
                          "aria-label": "albumArtist",
                        }}
                        value={this.state.albumDetails.albumArtist || ""}
                      />
                    </div>
          
              
              </Grid> 
              <Grid item xs={6}>
                <div className={classes.globalContentCreate}>
                  <label
                    className={classes.globalCreateLabel}
                    aria-label="Input field for Catalog #"
                  >
                    Catalog # :{" "}
                  </label>
                  <TextInput
                    name="catNumber"
                    type="text"
                    classes={classes}
                    handleChange={this.handleValChange}
                    errors={this.state.errors || {}}
                    inputProps={{
                      "aria-label": "Catalog #",
                    }}
                    value={this.state.albumDetails.catNumber || ""}
                  />
                </div>      
              </Grid> 
            </>
          )}
     

        <Grid item xs={6}>
          <div className={classes.globalContentCreate}>
            <label
              className={classes.globalCreateLabel}
              aria-label="Input field for record label"
            >
              Record Label :{" "}
            </label>
            <TextInput
              name="recordLabel"
              type="text"
              classes={classes}
              handleChange={this.handleValChange}
              errors={this.state.errors || {}}
              inputProps={{
                "aria-label": "Record label",
              }}
              value={this.state[type === contentRequestTypes.ALBUM ? "albumDetails":"trackDetails"].recordLabel || ""}
            />
          </div>
        </Grid>

        <Grid item xs={6}>
          <div className={classes.globalContentCreate}>
            <label
              className={classes.globalCreateLabel}
              aria-label="Input field for publisher"
            >
              Publisher :{" "}
            </label>
            <TextInput
              name="publisher"
              type="text"
              classes={classes}
              handleChange={this.handleValChange}
              errors={this.state.errors || {}}
              inputProps={{
                "aria-label": "publisher",
              }}
              value={this.state[type === contentRequestTypes.ALBUM ? "albumDetails":"trackDetails"].publisher || ""}
            />
          </div>
        </Grid>

        {type !== contentRequestTypes.ALBUM && 
          <Grid item xs={6}>
            <div className={classes.globalContentCreate}>
              <label
                className={classes.globalCreateLabel}
                aria-label="Input field for alternate track title"
              >
                Alternate Track Title :{" "}
              </label>
              <TextInput
                name="altTrackTitle"
                type="text"
                classes={classes}
                handleChange={this.handleValChange}
                errors={this.state.errors || {}}
                inputProps={{
                  "aria-label": "Alternate track title",
                }}
                value={this.state.trackDetails.altTrackTitle || ""}
              />
            </div>
          </Grid>
        }

        <Grid item xs={type !== contentRequestTypes.ALBUM ? 6 : 12}>
          <div className={classes.globalContentCreate}>
            <label
              className={classes.globalCreateLabel}
              aria-label="Input field for distributor name"
            >
              Distributor Name(If Applicable) :{" "}
            </label>
            <TextInput
              name="distributor"
              type="text"
              classes={classes}
              handleChange={this.handleValChange}
              errors={this.state.errors || {}}
              inputProps={{
                "aria-label": "distributor",
              }}
              value={this.state[type === contentRequestTypes.ALBUM ? "albumDetails":"trackDetails"].distributor || ""}
            />
          </div>
        </Grid>


        <Grid item xs={12}>
        <div className={classes.globalContentCreate}>
            <label
              className={classes.globalCreateLabel}
              aria-label="Input field for notes"
            >
              Notes :{" "}
            </label>
            <div className={clsx(classes.composeTextAreaContReq , this.state.errors && this.state.errors['notes']? classes.emptyData : null )}>
              <TextareaAutosize
                rowsMax={10}
                name="notes"
                aria-label={"Notes"}
                onChange={this.handleValChange}
                value={this.state[type === contentRequestTypes.ALBUM ? "albumDetails":"trackDetails"].notes || ""}
                />
              { this.state.errors && this.state.errors['notes'] && (
              <span>{this.state.errors['notes']}</span>
              )}
            </div>
          </div>
      
        </Grid>
       

      </Grid>  
      
      

      </div>
      
        </DialogContent>
        <DialogActions  className={classes.dialogFooter}>
<div className={classes.dialogSubmitButton}>
<div className={classes.warningText}>
            WARNINGS:
            <div>MP3 formats are only available for permissioned users.  </div>
            <div> Requests will be dealt with Monday to Friday between 09:00 - 18:00</div>
          </div>
          
          <Button
            className={clsx(
              classes.dialogYesButton,
            )}
            onClick={(e) => {
              this.clickCreate();
            }}
            color="primary"
            autoFocus
          >
            Send
          </Button>
          <Button
            className={clsx(
              classes.dialogYesButton,
            )}
            onClick={(e) => {
              this.sendAndCreateNew();
            }}
            color="primary"
            autoFocus
          >
            Send and Create New Request
          </Button>
</div>
         
    
        </DialogActions>
      </Dialog>
        </div> 
    );
  }
}
